module.exports = __webpack_public_path__ + "static/media/img-coming-offers.e6772062.png";